@if (totalData) {
  <div class="total">
    <div class="total__header">
      {{ titleKey | translate }}
    </div>
    <div class="total__values">
      @for (dataSet of totalData.series; track $index) {
        <div class="total__values__item">
          <div class="total__values__item__numbers">
            <div
              class="total__values__item__numbers--color"
              [style.background]="dataSet.color"></div>
            <div class="total__values__item__numbers--value">
              {{ dataSet.data[0] }}
            </div>
          </div>
          <div class="total__values__item--label">
            {{ dataSet.labelTranslationKey || dataSet.label | translate }}
          </div>
        </div>
      }
    </div>
  </div>
}
